import React, { useState } from 'react';
import CloseIcon from '@mui/icons-material/Close';
import ReplayIcon from '@mui/icons-material/Replay';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { PermMedia, SyncAlt as SyncAltIcon, Undo } from '@mui/icons-material';
import { Divider, IconButton, Menu, MenuItem } from '@mui/material';
import { makeStyles } from '@mui/styles';

import TooltipComponent from '@/main/components/shared/tooltip/tooltipComponent';
import { ReasonTypeEnum } from '@/main/services/enum/ReasonEnum';
import { getTranslateByKey } from '@/main/services/utils';
import { editSquareSVG } from '@/main/components/shared/icons/svg/editSquareSVG';

import * as S from './styles';
import colors from '@/main/style/colors';

const useStyles = makeStyles({
  popperCustom: { marginLeft: 15 },
  root: {
    '& .MuiPaper-root': {
      backgroundColor: colors.white
    }
  }
});

interface IBUTTONOJBECT {
  id: string;
  icon: React.ReactNode | React.JSX.Element;
  title: string;
  condition: boolean,
  onClick: (() => void) | (() => {});
}
interface IAreaButtonsRowPartProps {
  showReassignButton: boolean;
  showEditButton: boolean;
  showImagesButton: boolean;
  showReopenCancelReturn: boolean;
  showButtonCancel: boolean;
  showButtonReturn: boolean;
  handleClickReopenCancelReturn: () => void;
  handleReassignPart: () => void;
  handleClickButtonImages: () => void;
  handleEditPart: () => void;
  handleRemovePart: (reason: ReasonTypeEnum) => void;
}

function AreaButtonsRowPart({
  showReassignButton,
  showEditButton,
  showImagesButton,
  showReopenCancelReturn,
  showButtonCancel,
  showButtonReturn,
  handleRemovePart,
  handleClickReopenCancelReturn,
  handleReassignPart,
  handleClickButtonImages,
  handleEditPart,
}: IAreaButtonsRowPartProps) {
  const classesMUI = useStyles();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const BUTTONS_OJBECT: IBUTTONOJBECT[] = [
    {
      id: 'reassign-button',
      icon: <SyncAltIcon />,
      title: getTranslateByKey('information.reassignPartToAnotherSupplier'),
      condition: showReassignButton,
      onClick: handleReassignPart,
    },
    {
      id: 'edit-part',
      icon: editSquareSVG(),
      title: getTranslateByKey('information.edit'),
      condition: showEditButton,
      onClick: handleEditPart,
    },
    {
      id: 'view-images',
      icon: <PermMedia />,
      title: getTranslateByKey('information.viewImages'),
      condition: showImagesButton,
      onClick: handleClickButtonImages,
    },
    {
      id: 'reopen-part',
      icon: <Undo />,
      title: getTranslateByKey('control.reopenPart'),
      condition: showReopenCancelReturn,
      onClick: handleClickReopenCancelReturn,
    },
    {
      id: 'cancel-part',
      icon: <CloseIcon />,
      title: getTranslateByKey('information.cancel'),
      condition: showButtonCancel,
      onClick: () => handleRemovePart(ReasonTypeEnum.Cancel),
    },
    {
      id: 'return-part',
      icon: <ReplayIcon />,
      title: getTranslateByKey('information.return'),
      condition: showButtonReturn,
      onClick: () => handleRemovePart(ReasonTypeEnum.Part),
    },
  ]
  const handleClickThreeDots = (event: React.MouseEvent<HTMLButtonElement>) => {

    setAnchorEl(event.currentTarget)
  };
  const handleCloseThreeDots = () => {
    setAnchorEl(null);
  };
  const mountId = (id: string) => `id-infoOrder-rowpart-${id}-button`;
  const showThreeDots = BUTTONS_OJBECT.some(item => item.condition);
  return (
    <S.BoxButtons>
      <S.AreaButtonsIcons>
        {BUTTONS_OJBECT.map((itemButton, index) => (
          itemButton.condition && (
            <TooltipComponent
              key={index}
              placement="top"
              title={itemButton.title}
              stylePopper={classesMUI.popperCustom}>
              <IconButton
                id={mountId(itemButton.id)}
                onClick={itemButton.onClick}
              >
                {itemButton.icon}
              </IconButton>
            </TooltipComponent>
          )
        ))}
      </S.AreaButtonsIcons>
      {showThreeDots && (
        <S.AreaButtons3Dots>
          <TooltipComponent
            placement="top"
            title={getTranslateByKey('information.clickToSeeTheActions')}
            stylePopper={classesMUI.popperCustom}>
            <IconButton
              id='id-infoOrder-rowpart-three-dots-button'
              onClick={handleClickThreeDots}
            >
              <MoreVertIcon className="ignore-click" />
            </IconButton>
          </TooltipComponent>
          <Menu
            id={mountId('menu')}
            anchorEl={anchorEl}
            open={Boolean(anchorEl)}
            onClose={handleCloseThreeDots}
            elevation={2}
            MenuListProps={{
              'aria-labelledby': 'basic-button'
            }}
            anchorOrigin={{
              vertical: 'bottom',
              horizontal: 'center'
            }}
            transformOrigin={{
              vertical: 'top',
              horizontal: 'right'
            }}
            className={classesMUI.root}
            style={{ zIndex: 1 }}
          >
            {BUTTONS_OJBECT.map((itemButton, index) => (
              itemButton.condition && (
                <MenuItem
                  key={index}
                  onClick={() => {
                    handleCloseThreeDots()
                    itemButton.onClick()
                  }}
                >
                  <Divider />
                  {itemButton.title}
                </MenuItem>
              )
            ))}

          </Menu>
        </S.AreaButtons3Dots>
      )}
    </S.BoxButtons>
  )
}

export default AreaButtonsRowPart
